import { Box, Text } from '@chakra-ui/react'

export default function TaskDescription({ children }: any) {
  return (
    <Box pl={4}>
      <Text fontSize={'sm'} textAlign={'justify'}>
        {children}
      </Text>
    </Box>
  )
}
